import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import UrlEncode from '../../components/UrlEncode.vue';
export default {
  __name: 'UrlEncodePage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "URL 编码/解码",
        "current-page": "url"
      }, {
        default: _withCtx(() => [_createVNode(UrlEncode)]),
        _: 1
      });
    };
  }
};